import React from "react";
import { useParams } from "react-router-dom";
import services from "../data/services";
import Contact from "./Contact";
import "../styles/service-detail.css";

export default function ServiceDetail() {
  const { id } = useParams();

  // selected service
  const service = services.find((s) => s.id === id);

  if (!service) {
    return (
      <h2 style={{ padding: "100px", textAlign: "center" }}>
        Service Not Found
      </h2>
    );
  }

  return (
    <>
      {/* SERVICE DETAILS SECTION */}
      <section className="service-detail">
        <div className="service-detail-container">
          <h1 className="service-title">{service.title}</h1>
          <p className="service-sub">{service.highlight}</p>

          <div className="service-detail-content">
            <div className="service-image-wrapper">
              <img src={service.image} alt={service.title} />
            </div>

            <div className="service-text">
              <p className="service-desc">{service.longDesc || service.desc}</p>
              <p className="service-desc">
                At <strong>HomoDial Healthcare Solution Pvt. Ltd.</strong>, we
                ensure this service is delivered with professional expertise,
                modern medical equipment, and compassionate care — all within
                the comfort of your home.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* EXACT SAME CONTACT SECTION */}
      <Contact />
    </>
  );
}



